import { apiClient } from "rp-components"
import { DirectoryInfo } from "rp-components"

export interface SupportService { 
    getSupportDocuments(directory: string): Promise<DirectoryInfo>
}


class SupportServiceImpl implements SupportService {
    static instance?: SupportService = undefined

    private constructor() {}

    static getInstance(): SupportService {
        if (SupportServiceImpl.instance == undefined) {
            SupportServiceImpl.instance = new SupportServiceImpl()
        }
        return SupportServiceImpl.instance
    }

    async getSupportDocuments(directory: string) {
        return await apiClient.get<DirectoryInfo>(`/documentation/directory?path=${directory}`)
    }
}

export default SupportServiceImpl.getInstance()
